import styled from "styled-components";
import { breakpoints } from "styles";

export const KelasLiveFeatureBlockContainer = styled.section`
  background-color: ${({ theme }) => theme.colors.brand[50]};
  padding: 40px 0;
`;

export const KelasLiveFeatureBlockSection = styled.section<{
  flipMedia: boolean;
}>`
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  border: 2px solid ${({ theme }) => theme.colors.neutral["200"]};
  @media ${breakpoints.tablet} {
    padding: 32px 0;
    display: flex;
    flex-direction: ${({ flipMedia }) => (flipMedia ? "row-reverse" : "row")};
    align-items: center;
    justify-content: space-around;
  }
`;

export const KelasLiveFeatureBlockContent = styled.div`
  text-align: left;

  @media ${breakpoints.tablet} {
    max-width: 400px;
  }
`;
export const KelasLiveFeatureBlockTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.primary};
  line-height: 1.25;
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  margin: 22px 0 12px 0;
  color: ${({ theme }) => theme.colors.neutral["900"]};

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes["3xl"]};
  }
`;

export const KelasLiveFeatureBlockDesc = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.neutral[800]};
  line-height: 1.5;

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes["xl"]};
  }
`;

export const KelasLiveFeatureBlockImageWrapper = styled.figure`
  margin: 0;
  position: relative;
  width: 100%;
  height: 100%;

  @media ${breakpoints.tablet} {
    max-width: 460px;
  }
`;

export const KelasLiveFeatureSectionTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  line-height: 1.2;
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  margin: 22px 0 12px 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.neutral["900"]};

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes["4xl"]};
    max-width: 600px;
    margin: 0 auto;
  }
`;
